import React from 'react';
import { clsx } from 'clsx';

interface AuthInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  name: string;
}

export const AuthInput: React.FC<AuthInputProps> = ({ 
  label, 
  error, 
  name, 
  className, 
  ...props 
}) => {
  return (
    <div className="space-y-1">
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium text-foreground"
        >
          {label}
        </label>
      )}

      <input
        id={name}
        name={name}
        className={clsx(
          "w-full px-4 py-3 rounded-lg border border-border bg-background text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring transition-colors",
          error && "border-destructive focus:ring-destructive focus:border-destructive",
          className
        )}
        {...props}
      />

      {error && (
        <p className="text-xs text-destructive mt-1">
          {error}
        </p>
      )}
    </div>
  );
};